exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adLocation__location___3r63d {\n  line-height: 24px;\n  color: #8e8e8e;\n  font-weight: 400;\n  font-size: 16px;\n  color: #000000;\n  opacity: 75%; }\n", ""]);

// exports
exports.locals = {
	"location": "adLocation__location___3r63d"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/AdSummary/AdLocation/adLocation.scss
// module id = 3898
// module chunks = 6